import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { routeBlackList } from "src/@types/RouteBlacklist";

declare global {
	interface Window {
		ZohoDeskAsap?: { invoke: (action: string, target: string) => void };
		ZohoDeskAsapReady?: (callback?: () => void) => void;
		ZohoDeskAsapReadyStatus?: boolean;
		ZohoDeskAsap__asyncalls?: Array<(() => void) | undefined> | null;
	}
}

export const ZohoDeskPlugin = () => {
	const location = useLocation();
	const blackList = routeBlackList;

	const blacklisted = blackList.some((b) =>
		location.pathname.toLowerCase().startsWith(b.toLowerCase())
	);

	// The script is only injected once the user is on a non-blacklisted route,
	// so pages like the NeuraPulse callback never load Zoho at all.
	useEffect(() => {
		if (blacklisted || document.getElementById("zohodeskasapscript")) {
			return;
		}

		window.ZohoDeskAsapReady = (callback?: () => void) => {
			const asyncCalls = (window.ZohoDeskAsap__asyncalls =
				window.ZohoDeskAsap__asyncalls || []);
			if (window.ZohoDeskAsapReadyStatus) {
				if (callback) {
					asyncCalls.push(callback);
				}
				asyncCalls.forEach((call) => call && call());
				window.ZohoDeskAsap__asyncalls = null;
			} else if (callback) {
				asyncCalls.push(callback);
			}
		};

		const script = document.createElement("script");
		script.id = "zohodeskasapscript";
		script.src =
			"https://desk.zoho.com/portal/api/web/asapApp/563032000061879154?orgId=733170690";
		script.defer = true;
		document.body.appendChild(script);
	}, [blacklisted]);

	useEffect(() => {
		if (window.ZohoDeskAsapReady) {
			window.ZohoDeskAsapReady(() => {
				if (window.ZohoDeskAsap) {
					window.ZohoDeskAsap.invoke(blacklisted ? "hide" : "show", "app.launcher");
				}
			});
		}
	}, [location.pathname, blacklisted]);

	return <></>;
};
